module.exports = __webpack_public_path__ + "media/images/headphones-mic-d22a5290b8d8cd6b5747f532aacb9355.svg";